export default {
  productName: 'Ankle Wraps',
  pathId: 'fightcamp-ankle-wraps',
  description: 'Designed for kickboxing, the ankle wraps provide joint support while securing your Trackers. Features a discreet pocket near the ankle to keep your trackers stable and secure through every strike and combination.',
  shortDescription: 'Ankle Wraps',
  isSoldOut: false,
  primaryImg: {
    src: 'https://a.storyblok.com/f/152150/1200x825/a7de7b3686/fc_product_shoot_2025-33.jpg',
    alt: 'FightCamp ankle wraps',
  },
  lifestyleImage: {
    src: 'https://a.storyblok.com/f/152150/500x500/2720267f44/500x500_ankle.jpg',
    alt: 'FightCamp Ankle Wraps for kickboxing',
  },
  includesModalCopy: {},
  assets: [
    {
      src: 'https://a.storyblok.com/f/152150/1200x825/a7de7b3686/fc_product_shoot_2025-33.jpg',
      alt: 'FightCamp ankle wraps',
    },
    {
      src: 'https://a.storyblok.com/f/152150/1200x825/bb7c0d9f9f/fc_product_shoot_2025-29.jpg',
      alt: 'FightCamp ankle wraps with tracker',
    },
    {
      src: 'https://a.storyblok.com/f/152150/1200x825/71d1ee508c/fc_product_shoot_2025-28.jpg',
      alt: 'FightCamp ankle wraps on a person',
    },
    {
      src: 'https://a.storyblok.com/f/152150/1200x825/99c2fc4f4a/fc_product_shoot_2025-32.jpg',
      alt: 'FightCamp ankle wraps on a person',
    },
  ],
  features: [
    {
      title: 'Features',
      copy: [
        'Secure pocket for kick trackers',
        'Easy to put on and stays in place throughout training',
        'Supports ankle joints during kickboxing workouts',
      ],
    },
    {
      title: 'Size & Fit',
      copy: [
        'Available in two sizes: S/M and L/XL',
        'Stretchable fabric ensures a snug, adaptive fit',
      ],
    },
    {
      title: 'Materials & Care',
      copy: [
        'Made from 80% polyester, 20% spandex',
        'Machine washable (cold wash) and tumble dry low',
      ],
    },
  ],
};
